import React from "react";
import { db } from "../../../firebase-config";
import { getDoc, doc } from "firebase/firestore";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  Card,
  CardContent,
} from "@mui/material";
import TransactionsVisual from "./TransactionsVisual";

function Suburbs() {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState();
  const [year, setYear] = React.useState();
  const [years, setYears] = React.useState([]);
  const [transactionsTypes, setTransactionsTypes] = React.useState();
  const [transactionType, setTransactionType] = React.useState();

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
  };

  async function getQueryInfo({ id }) {
    const docRef = doc(db, "land-transactions-info", id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    setData(data);
    setYears(data["years"]);
    setYear(data["latest-year"]);
    setTransactionsTypes(data["transactions-types"]);
    setTransactionType(data["transactions-types"][0]);
    setLoading(false);
  }

  React.useEffect(() => {
    getQueryInfo({ id: "data" });
  }, []);

  return loading ? (
    <h1>Loading</h1>
  ) : data.length !== 0 ? (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="transaction-type-select-label">
                Transaction Type
              </InputLabel>
              <Select
                labelId="transaction-type-select-label"
                id="transaction-type-select"
                value={transactionType}
                label="Transaction Type"
                onChange={handleTransactionTypeChange}
              >
                {transactionsTypes.map((type) => {
                  return <MenuItem value={type}>{type}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="year-select-label">Year</InputLabel>
              <Select
                labelId="year-select-label"
                id="year-select"
                value={year}
                label="Year"
                onChange={handleYearChange}
              >
                {years.map((yr) => {
                  return <MenuItem value={yr}>{yr}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ 
        marginTop: "10px",
      }}>
      <Card>
        <TransactionsVisual year={year} type={transactionType} />
      </Card>
      </Box>
      
    </Box>
  ) : (
    <h6>No data Available</h6>
  );
}

export default Suburbs;
